import React from 'react';
import PropTypes from 'prop-types';
import { Col } from 'reactstrap';

function FlavourCard({ title, text }) {
  if (!text) return <></>;

  return (
    <Col sm={12}>
      <h5 className="text-muted mb-0">{title}</h5>
      <p className="text-muted">{text}</p>
    </Col>
  );
}

FlavourCard.propTypes = {
  title: PropTypes.string.isRequired,
  text: PropTypes.string,
};

FlavourCard.defaultProps = {
  text: '',
};

export default FlavourCard;
